// src/store/thunks/user/updateMeThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withLoader, withErrorHandling } from '@/store/thunks/thunkWrappers';
import type { User } from '@/types/user/User';

export const updateMeThunk = createAppAsyncThunk<
  User,
  { id: string } & Partial<Pick<User, 'name' | 'phone' | 'department'>>
>(
  'user/updateMe',
  withLoader(
    withErrorHandling(
      async(params, { extra: { userService } }) => {
        const { id, name, phone, department } = params;

        // Perform update
        await userService.updateMe(id, name, phone, department);

        // Fetch the latest user profile
        return await userService.getMe(id);
      }
    )
  )
);
